module.exports = __webpack_public_path__ + "img/mondu.f481b06.svg";